
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.08 10.373a.41.41 0 01.097-.582L2.745 7.78c-.213-.31.037-.416.037-.416l-.207-.553c-.185-.385.175-.755.175-.755l2.205-1.638a.662.662 0 01.94.181l.444-.251a.367.367 0 01.13-.504l2.358-1.882v-.865c.028-.473.275-.277.275-.277l.787.78S11.595.142 11.715.034c.12-.108.227.078.227.078s.1.118.037.189c-.062.07-1.638 1.51-1.638 1.51l.045.384-.143.159-.25-.252-.427.41a.641.641 0 01-.152.6L7.566 5.065c-.338.284-.5.078-.5.078l-.375.405c-.157.237.537.833.537.833l-.062.171a6.883 6.883 0 001.878 1.361L8.215 9.19a5.098 5.098 0 01-1.719-1.195l-.706.398c-.63.47-.515.777-.515.777l.117.858c.425.199.078.385.078.385l-.657.302c-.435.277-.425-.073-.425-.073l-.055-1.686c-.265-.606-.66-.307-.66-.307-.47.418-.89.892-1.248 1.412l-.133 1.477c-.25.722-.684.382-.684.382l-1.08-1.092-.449-.455z"}})])
          )
        }
      }
    